/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class Artifact extends models.AgentFieldsBase {
    getFixupPrototypeFunction() { return Artifact.fixupPrototype; }

    static newInstance(model: Partial<Artifact>): Artifact {
        let obj = Object.assign(new Artifact(), model);
        Artifact.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<Artifact>): Artifact {
        if (!model) return null;
        return Artifact.newInstance(<Artifact> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: Artifact) {
        if (!obj) return;

        models.Artifact.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: Artifact): boolean {
        if (models.AgentFieldsBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, Artifact.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.version === undefined) {
            this.version = 0;
        }
    }

    /**
     * ID of the tenant
     */
    tenant_id: string;

    /**
     * Username of the user who created the artifact (legacy identity, kept for artifacts saved before owner_id existed).
     */
    created_by: string;

    /**
     * Stable Identity-service user id of the artifact's owner. Absent on artifacts saved before this field existed -- callers fall back to created_by for those.
     */
    owner_id: string;

    /**
     * ID of the agent the artifact was generated from
     */
    agent_id: string;

    /**
     * ID of the chat the artifact was saved from
     */
    source_chat_id: string;

    /**
     * ID of the conversation turn the artifact was saved from
     */
    source_conversation_id: string;

    /**
     * Title of the artifact
     */
    title: string;

    /**
     * Description of the artifact
     */
    description: string;

    /**
     * Kind of artifact
     */
    kind: models.ArtifactKind;

    /**
     * Rendered HTML content of the artifact
     */
    html_content: string;

    /**
     * Reference to a generated PDF rendition, if any
     */
    pdf_ref: string;

    /**
     * Original prompt used to generate the artifact, for deterministic regeneration
     */
    source_prompt: string;

    /**
     * Original execution parameters used to generate the artifact, for deterministic regeneration
     */
    source_params: any;

    /**
     * Tags for search/organization
     */
    tags: Array<string>;

    /**
     * Indicates if the artifact is currently pinned to the Insights dashboard
     */
    is_pinned: boolean = false;

    /**
     * Revision number, starting at 1. Incremented when the artifact is regenerated or edited; the title carries a matching _vN suffix from v2 onward.
     */
    version: number;

}
